import { render, staticRenderFns } from "./process-type-modal.vue?vue&type=template&id=a4ca47c2&"
import script from "./process-type-modal.vue?vue&type=script&lang=js&"
export * from "./process-type-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports